import React from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Spinner from "../layout/spinner";
import { authDebug, loginUrl } from "../utils/api";
import { rememberCheckoutReturnPath } from "../utils/checkout";

export const PrivateRoute = ({
  component: Component,
  auth: { authenticated, loading },
  ...rest
}) => {

  return (
  <Route
      {...rest}
      render={(props) => {
        if (loading) {
          return <Spinner />
        } else if (authenticated) {
          return <Component {...props} />
        } else {
          const returnPath = rememberCheckoutReturnPath(props.location);
          authDebug("private-route:redirect-login", {
            path: returnPath,
            authenticated,
            loading,
            hasLocalStorageToken: Boolean(localStorage.token)
          });
          window.location.href = loginUrl();
          return <></>
        }
        
      }}
  />
)};

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(PrivateRoute);
